import React, { memo } from 'react'
import { RegionTitle, RegionSubtitle, ArrowIcon, RegionRow, RegionTexts, LinkWrapper } from './vacation-region-styles'
import { RegionTransport } from '../../transports/region-landing-page-transport'
import ExternalLink from '../common/external-link'

interface Props extends RegionTransport {
    isLast?: boolean
    forceBorder?: boolean
}

const VacationRegion: React.FC<Props> = ({ url, name, subregions, noCrawl, isLast, forceBorder }) => {
    return (
        <RegionRow $isLast={isLast} $forceBorder={forceBorder}>
            <LinkWrapper href={url} noCrawl={noCrawl}>
                <RegionTexts>
                    <RegionTitle>{name}</RegionTitle>
                    {subregions && subregions.length > 0 && (
                        <RegionSubtitle>
                            {subregions
                                .filter(sr => sr.url)
                                .map((sr, idx, arr) => (
                                    <React.Fragment key={sr.url}>
                                        <ExternalLink href={sr.url} noCrawl={sr.noCrawl}>
                                            {sr.title}
                                        </ExternalLink>
                                        {idx !== arr.length - 1 && ', '}
                                    </React.Fragment>
                                ))}
                        </RegionSubtitle>
                    )}
                </RegionTexts>
                <ArrowIcon />
            </LinkWrapper>
        </RegionRow>
    )
}

export default memo(VacationRegion)
